// YunFooter.js

import { useState, useEffect, useRef } from 'react'
import './YunFooter.css';

import YunIcon from '../YunIcon/YunIcon'
import YunUser from '../YunUser/YunUser'
import CheckBox from '../CheckBox/CheckBox'

import Switch from '@material-ui/core/Switch';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Snackbar from '@material-ui/core/Snackbar';

import {
    removeToken,
} from '../../../utils/auth';
import { openWindow, compareVersions } from '../../../utils/index';
import { useHistory } from "react-router-dom";

import {
    cppOpenUrlUseDefaultBrowser,
    cppGetAppInfo,
    cppInstallAutoTunePlugin,
    cppInstallQQMusicAutoTunePlugin,
    cppInstallKwMusicPlugin,
} from '../../../api/cpp'

import {
    setKuGouDefaultDev,
    setKuGouOriginalDev,
    setFanXingDefaultDev,
    setFanXingOriginalDev,
    setKuWoDefaultDev,
    setKuWoOriginalDev,
    setNetEaseDefaultDev,
} from './HandlePlayerOutDev';
import { checkAndInstallDriver, checkAccHelperFiles } from '../AccHelper/tools';

import { clearLocalStorage } from '../../App/local';

const appInfo = cppGetAppInfo();

// 3.9.4以上版本
const isNewVersion394 = compareVersions(appInfo && appInfo.version, "3.9.4");
// const isNewVersion394 = true;
// 3.9.8以上版本
const isNewVersion398 = compareVersions(appInfo && appInfo.version, "3.9.8");
// const isNewVersion398 = true;

const YunFooter = function(props) {
    const { pageset, handlePageset, productInfo, reloadLocalCnf, restoreServerDefaults, showmenu, setshowmenu, AccModel, setAccModel } = props
    const switchConfig = {
        defaultValue: true
    }

    // const [showmenu, setshowmenu] = useState(false);
    const [showDia, setShowDia] = useState(false);
    const [showPlayerCloseDia1, setShowPlayerCloseDia1] = useState(false);
    const [showPlayerCloseDia2, setShowPlayerCloseDia2] = useState(false);
    const [showVirtualDeviceInstallReselt, setShowVirtualDeviceInstallReselt] = useState(false);
    const [showAccHelperMissingDia, setShowAccHelperMissingDia] = useState(false);
    const [SnackbarOpen, setSnackbarOpen] = useState(false);
    const [virtualDeviceInstallReseltBtnState, setVirtualDeviceInstallReseltBtnState] = useState('继续');
    const [virtualDeviceInstallReselt, setVirtualDeviceInstallReselt] = useState('');
    const [showUpdateTips, setShowUpdateTips] = useState(true);
    const [menuBoxHeight, setMenuBoxHeight] = useState(0);
    const [skin, setSkin] = useState("default");
    const menuRef = useRef(null);
    const [menuPos, setMenuPos] = useState(76);
    const [isAutoTune, setSwitch] = useState(switchConfig.defaultValue);
    
    // 自定义下拉框状态
    const [selectOpen, setSelectOpen] = useState(false);

    const history = useHistory();

    useEffect(() => {
        if (productInfo.version && productInfo.emusicDownUrl) {
            // 获取当前云端提供的最新版本号
            const latestVersion = productInfo.emusicDownUrl.match(/(v\d+\.\d+\.\d+)\.exe$/)[1]
            // 如果当前版本是最新版本 则菜单顶部不展示提示框
            if (latestVersion === productInfo.version) {
                setShowUpdateTips(false)
            }
        }
    }, [productInfo])

    useEffect(() => {
        if (showmenu) {
            menuRef.current.focus()
        }
    }, [showmenu]);
    
    useEffect(() => {
        if (isNewVersion394) {
            const local_skin = window.localStorage.getItem('sy_theme');
            if (['default', 'anhui', 'canglv', 'mozi', 'yunhong'].includes(local_skin)) {
                setSkin(local_skin)
            }
        }
    }, [])

    // 操作页面功能
    function changePageSet(e, type) {
        if (e.preventDefault) e.preventDefault()
        if (e.stopPropagation) e.stopPropagation()
        if (pageset.hasOwnProperty(type)) {
            const temp = {}
            temp[type] = !pageset[type]
            handlePageset(temp);
        }
    }

    // 自动电音
    function handleChangeSwitch(e, value) {
        setSwitch(value)
        props.setEnableAutotune(value)
    }

    // 获取menubox高度
    const handleMenuBoxRef = (node) => {
        if (node && node.offsetHeight) {
            setMenuBoxHeight(node.offsetHeight)
        }
    }
    const clickShowMenu = (e) => {
        if (e.preventDefault) e.preventDefault()
        if (e.stopPropagation) e.stopPropagation()
        const h = menuBoxHeight ? menuBoxHeight + 15 : 445
        const posTop = e.clientY - h
        if (posTop < 40) {
            setMenuPos(40)
        } else {
            setMenuPos(posTop)
        }
        setshowmenu(true)
    };
    const closeMenu = () => {
        setshowmenu(false);
        setSelectOpen(false);
    }

    const handleShowDia = (e) => {
        if (e.preventDefault) e.preventDefault();
        if (e.stopPropagation) e.stopPropagation();
        setShowDia(true);
    }
    const handleSetSkin = (e, skin) => {
        if (e.preventDefault) e.preventDefault();
        if (e.stopPropagation) e.stopPropagation();
        window.localStorage.setItem('sy_theme', skin);
        document.getElementsByTagName('body')[0].setAttribute('datatheme', skin);
        setSkin(skin)
    }
    // 清除缓存
    // 恢复默认 = 清掉本机设置，然后按【后台下发的配置】重建
    // restoreServerDefaults 会直接拉 /v3/em/uiextconf，把后台配的值写进本机（不依赖启动时缓存）
    const handleClearLocal = (e) => {
        setShowDia(false);
        clearLocalStorage();
        window.setTimeout(() => {
            if (typeof restoreServerDefaults === 'function') {
                restoreServerDefaults();
            } else {
                reloadLocalCnf(true);
            }
        }, 300);
    }
    
    // 展示伴奏模式切换下拉框
    const toggleSelect = (e) => {
        if (e.preventDefault) e.preventDefault();
        if (e.stopPropagation) e.stopPropagation();
        setSelectOpen(!selectOpen);
    };
    
    // 修改伴奏模式
    const handleSelectChange = (e, value) => {
        if (e.preventDefault) e.preventDefault();
        if (e.stopPropagation) e.stopPropagation();
        if (AccModel === value) {
            return
        }
        // setAccModel(value);
        setSelectOpen(false);  // 优先关闭菜单：必须同步，先让 React flush + 浏览器绘制
        if (value === "伴奏助手") {
            if (!isNewVersion398) {
                return
            }
            // 延迟到下一轮事件循环执行，避免上面的同步 C++ 调用阻塞菜单关闭
            setTimeout(() => {
                const missingFiles = checkAccHelperFiles();
                if (missingFiles.length > 0) {
                    console.log('AccHelper files missing:', missingFiles);
                    setShowAccHelperMissingDia(true); // 弹框提示，不 return，后续驱动安装继续执行
                }
                checkAndInstallDriver().then(isSuccess => {
                    const result = isSuccess ? '虚拟声卡完成安装' : '因安全软件阻止，虚拟声卡未能完成安装”'
                    setVirtualDeviceInstallReseltBtnState('继续');
                    setShowVirtualDeviceInstallReselt(true);
                    setVirtualDeviceInstallReselt(result);
                })
            }, 10);
        } else if (value === "播放器") {
            setShowPlayerCloseDia2(true)
        }
    };

    // 切换到伴奏助手模式 检测安虚拟声卡的后续处理
    const handleCheckDeviceEnd = (e) => {
        if (e.preventDefault) e.preventDefault();
        if (e.stopPropagation) e.stopPropagation();
        setShowVirtualDeviceInstallReselt(false);
        setShowPlayerCloseDia1(true)
    }

    const setPlayerDefaultDev = (isSetPlayer) => {
        if (isSetPlayer) {
            setKuGouDefaultDev()
            setFanXingDefaultDev()
            setKuWoDefaultDev()
            setNetEaseDefaultDev()
        }
        setShowPlayerCloseDia1(false)
        if (AccModel !== "伴奏助手") {
            setAccModel("伴奏助手")
        }
    }

    const handleInstallVirtualDevice = () => {
        checkAndInstallDriver().then(isSuccess => {
            const result = isSuccess ? '虚拟声卡完成安装' : '因安全软件阻止，虚拟声卡未能完成安装”'
            setVirtualDeviceInstallReseltBtnState('确定');
            setShowVirtualDeviceInstallReselt(true);
            setVirtualDeviceInstallReselt(result);
        })
    }

    const setPlayerOriginalDev = (isSetPlayer) => {
        if (isSetPlayer) {
            setKuGouOriginalDev()
            setFanXingOriginalDev()
            setKuWoOriginalDev()
        }
        setShowPlayerCloseDia2(false)
        if (AccModel !== "播放器") {
            setAccModel("播放器")
        }
    }
    
    // 注销
    const handleLogOut = () => {
        removeToken();
        history.push('/login');
    }
    // 打开内部其他窗口
    const handleOpenWindow = (e, route) => {
        if (e.preventDefault) e.preventDefault()
        if (e.stopPropagation) e.stopPropagation()
        openWindow(`${window.location.origin}${window.location.pathname}#/${route}`);
    }
    // 主页
    const handleGoHome = (e) => {
        if (e.preventDefault) e.preventDefault()
        if (e.stopPropagation) e.stopPropagation()
        let homeUrl = productInfo.webSite.webSiteUrl || 'https://em.yunyinbox.com/#/index'
        cppOpenUrlUseDefaultBrowser(homeUrl)
    }

    const clickToHelp = (e) => {
        handleOpenWindow(e, "help")
        clickShowMenu(e)
    }

    const clickAddVocalsPlugin = (e) => {
        cppInstallAutoTunePlugin("emFix", false);
        cppInstallAutoTunePlugin('消人声', true);
        cppInstallQQMusicAutoTunePlugin('消人声');
        cppInstallKwMusicPlugin('消人声');
        setSnackbarOpen(true);
        setshowmenu(false);
    }

    const clickAddSharpPlugin = (e) => {
        cppInstallAutoTunePlugin("emFix", false);
        cppInstallAutoTunePlugin('升降调');
        cppInstallQQMusicAutoTunePlugin('升降调');
        cppInstallKwMusicPlugin('升降调');
        setSnackbarOpen(true);
        setshowmenu(false);
    }
    
    // 热榜
    const handleGoHottop = (e) => {
        if (e.preventDefault) e.preventDefault()
        if (e.stopPropagation) e.stopPropagation()
        openWindow("https://dianyinx.com/")
    }

    // 在浏览器打开下载页面
    const handleToDownloadPage = (e) => {
        if (e.preventDefault) e.preventDefault()
        if (e.stopPropagation) e.stopPropagation()
        const downUrl = `https://www.mic520.com/${productInfo.shortName}`
        cppOpenUrlUseDefaultBrowser(downUrl)
    }

    // 格式化网站名称：如果是两个汉字，中间加空格
    const formatWebSiteName = (name) => {
        if (!name) return '主 页'
        // 检查是否是两个汉字
        if (name.length === 2 && /^[\u4e00-\u9fa5]{2}$/.test(name)) {
            return name[0] + ' ' + name[1]
        }
        return name
    }

    const webSiteName = formatWebSiteName(productInfo && productInfo.webSite && productInfo.webSite.webSiteName)

    const showMenuItem = {
        home: true,
        about: true,
        help: true
    }
    if (productInfo && typeof productInfo.menuOption === "object" && !Array.isArray(productInfo.menuOption)) {
        showMenuItem.home = !!productInfo.menuOption.home
        showMenuItem.about = !!productInfo.menuOption.about
        showMenuItem.help = !!productInfo.menuOption.help
    }
    const menuClass = showmenu ? "Active" : ""

    let skikListEle = null;
    if (isNewVersion394) {
        skikListEle = (
            <div className="SkinList">
                <div className="SkinHeader">
                    UI风格
                </div>
                <div className="SkinItem" onClick={event => {handleSetSkin(event, 'default')}}>
                    <CheckBox value={skin === "default"}></CheckBox>
                    <span>默认</span>
                </div>
                <div className="SkinItem" onClick={event => {handleSetSkin(event, 'anhui')}}>
                    <CheckBox value={skin === "anhui"}></CheckBox>
                    <span>暗灰</span>
                </div>
                <div className="SkinItem" onClick={event => {handleSetSkin(event, 'canglv')}}>
                    <CheckBox value={skin === "canglv"}></CheckBox>
                    <span>苍绿</span>
                </div>
                <div className="SkinItem" onClick={event => {handleSetSkin(event, 'mozi')}}>
                    <CheckBox value={skin === "mozi"}></CheckBox>
                    <span>墨紫</span>
                </div>
                <div className="SkinItem" onClick={event => {handleSetSkin(event, 'yunhong')}}>
                    <CheckBox value={skin === "yunhong"}></CheckBox>
                    <span>韵红</span>
                </div>
            </div>
        )
    }

    let updateTipsEle = null;
    if (showUpdateTips) {
        updateTipsEle = (
            <div className="UpdateTips" onClick={handleToDownloadPage}>
                <div className="UpdateTipsTitle">电音助手升级啦~！</div>
                <div className="UpdateTipsContent">点击打开浏览器,下载您调音师的最新版</div>
            </div>
        )
    }

    return (
        <div className="YunFooter">
            <div className="MenuAndHelp">
                <div className="FooterMenu MenuBtn" onClick={clickShowMenu}>
                    <YunIcon icon="menu"></YunIcon>
                </div>
                {showMenuItem.help && (
                    <div className="Service UnderlineAnimation HoverMainColor MainColor" onClick={clickToHelp}>
                        <div className="Label">客 服</div>
                    </div>
                )}
            </div>
            <div className="AutoTune">
                <div className="Label MainColor">自动电音</div>
                <Switch
                    checked={isAutoTune}
                    onChange={handleChangeSwitch}
                    color="primary"
                    name="checkedB"
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                />
            </div>
            <div className={"MenuWrapper " + menuClass} ref={menuRef} tabIndex={0} onBlur={closeMenu}>
                <div className="MenuBox" ref={handleMenuBoxRef} style={{top: menuPos + 'px'}}>
                    <div className="UpdateTipsWrapper">
                        {updateTipsEle}
                    </div>
                    <div className="MenuBoxTop">
                        <YunUser promoteUrl={props.promoteUrl} vipInfo={props.vipInfo}></YunUser>
                        {skikListEle}
                    </div>
                    <div className="MenuBoxBottom">
                        <div className="MenuListWrapper">
                            <div className="MenuList">
                                <div className="MenuListHeader Line">歌曲基调</div>
                                <div className="MenuItem" onClick={event => {changePageSet(event, 'emBackup')}}>
                                    <CheckBox value={props.pageset.emBackup}></CheckBox>
                                    <span>备选基调</span>
                                </div>
                                <div className="MenuItem" onClick={event => {changePageSet(event, 'aiEm')}}>
                                    <CheckBox value={props.pageset.aiEm}></CheckBox>
                                    <span className="">Ai 分析</span>
                                </div>
                                <div className="MenuItem" onClick={event => {changePageSet(event, 'emSharp')}}>
                                    <CheckBox value={props.pageset.emSharp}></CheckBox>
                                    <span>手动修订</span>
                                </div>
                            </div>
                            <div className="BaseMenu">
                                <div className="MenuList">
                                    <div className="MenuItem Top0" onClick={handleGoHottop}>
                                        <YunIcon icon="hottop"></YunIcon>
                                        <span className="Center Flex1 FontSize11">榜 单</span>
                                    </div>
                                </div>
                                {
                                    showMenuItem.home && (
                                        <div className="MenuList">
                                            <div className="MenuItem Top0" onClick={handleGoHome}>
                                                <YunIcon icon="homeSvg"></YunIcon>
                                                <span className="Center Flex1 FontSize11">{webSiteName}</span>
                                            </div>
                                        </div>
                                    )
                                }
                                {
                                    showMenuItem.about && (
                                        <div className="MenuList">
                                            <div className="MenuItem Top0" onClick={(e) => handleOpenWindow(e, "about")}>
                                                <YunIcon icon="aboutSvg"></YunIcon>
                                                <span className="Center Flex1 FontSize11">关 于</span>
                                            </div>
                                        </div>
                                   )
                                }
                                <div className="MenuList">
                                    <div className="MenuItem Top0" onClick={handleLogOut}>
                                        <YunIcon icon="logoutSvg"></YunIcon>
                                        <span className="Center Flex1 FontSize11">退 出</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="MenuListWrapper">
                            <div className="MenuList AccHandle">
                                <div className="MenuListHeader Line">伴奏处理</div>
                                <div  className={"MySelect" + (selectOpen ? " Active" : "")} >
                                    <div className="MySelectLabel" onClick={toggleSelect}>
                                        <div className="MySelectLabelText">{AccModel}</div>
                                        <YunIcon iconClass={selectOpen ? "Rotate180" : ""} icon="expand"></YunIcon>
                                    </div>
                                    <div className="MySelectOptions">
                                        <div 
                                            className={"MySelectOption" + (AccModel === '播放器' ? " Selected" : "")}
                                            onClick={(e) => handleSelectChange(e, '播放器')}
                                        >
                                            播放器
                                        </div>
                                        <div 
                                            className={"MySelectOption" + (AccModel === '伴奏助手' ? " Selected" : "")}
                                            onClick={(e) => handleSelectChange(e, '伴奏助手')}
                                        >
                                            伴奏助手
                                        </div>
                                    </div>
                                </div>
                                {
                                    AccModel === '播放器' ? (
                                        <div className="MenuListMix">
                                            <div className="MenuItem Center" onClick={(e) => handleOpenWindow(e, "vocals")}>
                                                <span className='Line Blue Center Right0'>消原声设置</span>
                                            </div>
                                            <div className="MenuItem" onClick={clickAddVocalsPlugin}>
                                                <YunIcon icon="add"></YunIcon>
                                                <span className="FontSize11">消声插件</span>
                                            </div>
                                            <div className="MenuItem" onClick={event => {changePageSet(event, 'vocals')}}>
                                                <CheckBox value={props.pageset.vocals} ></CheckBox>
                                                <span className="FontSize11">原声消除</span>
                                            </div>
                                            <div className="MenuItem Center Line Top" onClick={(e) => handleOpenWindow(e, "sharpflat")}>
                                                <span className='Line Blue Center Right0'>升降调设置</span>
                                            </div>
                                            <div className="MenuItem" onClick={clickAddSharpPlugin}>
                                                <YunIcon icon="add"></YunIcon>
                                                <span className="FontSize11">变调插件</span>
                                            </div>
                                            <div className="MenuItem" onClick={event => {changePageSet(event, 'sharpFlat')}}>
                                                <CheckBox value={props.pageset.sharpFlat} ></CheckBox>
                                                <span className="FontSize11">伴奏升降</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="MenuListMix">
                                            <div className="MenuItemText">
                                                <span className="Color">1.</span>
                                                <span>全局升降调</span>
                                            </div>
                                            <div className="MenuItemText">
                                                <span className="Color">2.</span>
                                                <span>全局闪避</span>
                                            </div>
                                            <div className="MenuItemText">
                                                <span className="Color">3.</span>
                                                <span>全局消人声</span>
                                            </div>
                                            <div className="MenuItemText">
                                                <span className="Color">4.</span>
                                                <span>听原声跟唱</span>
                                            </div>
                                            <div className="MenuItemText">
                                                <span>在<span className="Color">助手</span>上操作</span>
                                            </div>
                                            {
                                                isNewVersion398 ? (
                                                    <div className="MenuItemText T">
                                                        <div className="Button1 Color" onClick={() => handleInstallVirtualDevice()}>
                                                            装虚拟声卡
                                                        </div>
                                                        <div className="Button1 Color" onClick={() => setShowPlayerCloseDia1(true)}>
                                                            设置播放器
                                                        </div>
                                                        <div className="Button1" onClick={() => setShowPlayerCloseDia2(true)}>
                                                            还原设置
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="MenuItemText T">
                                                        <span className="Color">需升级至新版【电音助手】</span>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    )
                                }
                                
                            </div>
                            <div className="MenuList">
                                <div className="MenuItem Top0" onClick={handleShowDia}>
                                    <YunIcon icon="menu_default"></YunIcon>
                                    <span>恢复默认</span>
                                </div>
                            </div>
                        </div>
                        
                        <div className="MenuList PageSet">
                            <div className="MenuListHeader Line MenuItem Top0" onClick={(e) => handleOpenWindow(e, "em")}>
                                <div className="LineBox Line Blue">
                                    <YunIcon icon="setting"></YunIcon>
                                    <span className=''>
                                        电音精调
                                    </span>
                                </div>
                            </div>
                            <div className="MenuItem" onClick={event => {changePageSet(event, 'emModel')}}>
                                <CheckBox value={props.pageset.emModel}></CheckBox>
                                <span>模式选择</span>
                            </div>
                            <div className="MenuItem" onClick={event => {changePageSet(event, 'emLinkage')}}>
                                <CheckBox value={props.pageset.emLinkage}></CheckBox>
                                <span>联动调节</span>
                            </div>
                            <div className="MenuItem" onClick={event => {changePageSet(event, 'shortcut')}}>
                                <CheckBox value={props.pageset.shortcut}></CheckBox>
                                <span>快捷切换</span>
                            </div>
                            <div className="MenuItem" onClick={event => {changePageSet(event, 'emRate')}}>
                                <CheckBox value={props.pageset.emRate}></CheckBox>
                                <span>强度</span>
                            </div>
                            <div className="MenuItem" onClick={event => {changePageSet(event, 'emHumanize')}}>
                                <CheckBox value={props.pageset.emHumanize}></CheckBox>
                                <span>拟 人</span>
                            </div>
                            <div className="MenuItem" onClick={event => {changePageSet(event, 'emVibrato')}}>
                                <CheckBox value={props.pageset.emVibrato}></CheckBox>
                                <span>颤 音</span>
                            </div>
                            <div className="MenuItem" onClick={event => {changePageSet(event, 'emFlex')}}>
                                <CheckBox value={props.pageset.emFlex}></CheckBox>
                                <span>弹 性</span>
                            </div>
                            <div className="MenuItem" onClick={event => {changePageSet(event, 'emTracking')}}>
                                <CheckBox value={props.pageset.emTracking}></CheckBox>
                                <span>跟 踪</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Dialog
                open={showDia}
                className="ClearLocalDia"
                onClose={() => {setShowDia(false)}} >
                <DialogTitle>
                    注意
                </DialogTitle>
                <DialogContent>
                    此操作将重置软件，所有设置还原到所属版本的初始值（但不会影响您对基调、升降调设定的记录）。是否继续？
                </DialogContent>
                <DialogActions>
                    <div className="YunBtn Small" onClick={() => setShowDia(false)}>取消</div>
                    <div className="YunBtn Small" onClick={handleClearLocal}>确认</div>
                </DialogActions>
            </Dialog>
            <Dialog
                open={showPlayerCloseDia1}
                className="HandlePlayerDia"
                onClose={(event, reason) => {
                        if (reason === 'backdropClick') return;
                        setShowPlayerCloseDia1(false);
                    }} >
                <DialogTitle>
                    注意
                </DialogTitle>
                <DialogContent>
                    <div>配合【伴奏助手】使用，自动设置的</div>
                    <div>播放器包括:</div>
                    <div>酷狗音乐、网易云音乐、QQ音乐、繁星直播、酷我音乐</div>
                    <div className="MarginTop">因此，本操作会关闭以上播放器。</div>
                    <div className="MarginTop">如点“取消”， 则需要您自行将所需使用的播放器输出设置为"播放器专用”通道。</div>
                </DialogContent>
                <DialogActions>
                    <div className="YunBtn Small Cancel" onClick={() => setPlayerDefaultDev(false)}>取消</div>
                    <div className="YunBtn Small" onClick={() => setPlayerDefaultDev(true)}>确认</div>
                </DialogActions>
            </Dialog>
            <Dialog
                open={showPlayerCloseDia2}
                className="HandlePlayerDia"
                onClose={(event, reason) => {
                    if (reason === 'backdropClick') return;
                    setShowPlayerCloseDia2(false);
                }} >
                <DialogTitle>
                    注意
                </DialogTitle>
                <DialogContent>
                    <div>使用【播放器】模式，将帮您恢复:</div>
                    <div>酷狗音乐、繁星直播、酷我音乐</div>
                    <div>为此前的设置，其它播放器需您自行设置。</div>
                    <div className="MarginTop">因此，本操作会关闭以上播放器。</div>
                </DialogContent>
                <DialogActions>
                    <div className="YunBtn Small Cancel" onClick={() => setPlayerOriginalDev(false)}>取消</div>
                    <div className="YunBtn Small" onClick={() => setPlayerOriginalDev(true)}>确认</div>
                </DialogActions>
            </Dialog>
            <Dialog
                open={showVirtualDeviceInstallReselt}
                className="HandlePlayerDia"
                onClose={(event, reason) => {
                    if (reason === 'backdropClick') return;
                    setShowVirtualDeviceInstallReselt(false);
                }} >
                <DialogTitle>
                    注意
                </DialogTitle>
                <DialogContent>
                    <div>{virtualDeviceInstallReselt}</div>
                </DialogContent>
                <DialogActions>
                    {
                        virtualDeviceInstallReseltBtnState === '继续' ? (
                            <div className="YunBtn Small" onClick={handleCheckDeviceEnd}>继续</div>
                        ) : (
                            <div className="YunBtn Small" onClick={() => setShowVirtualDeviceInstallReselt(false)}>确定</div>
                        )
                    }
                </DialogActions>
            </Dialog>
            <Dialog
                open={showAccHelperMissingDia}
                className="HandlePlayerDia"
                onClose={() => { setShowAccHelperMissingDia(false) }} >
                <DialogTitle>
                    注意
                </DialogTitle>
                <DialogContent>
                    <div>伴奏助手文件缺失，可能会影响正常使用，如有问题请联系客服</div>
                </DialogContent>
                <DialogActions>
                    <div className="YunBtn Small" onClick={() => setShowAccHelperMissingDia(false)}>知道了</div>
                </DialogActions>
            </Dialog>
            <Snackbar
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                open={SnackbarOpen}
                autoHideDuration={2000}
                onClose={() => setSnackbarOpen(false)}
                message="已执行，请重启播放器"
            />
        </div>
    )
}

export default YunFooter;
